import React, {useCallback, useMemo, useState} from 'react'
import {gpsPermissionState} from 'types'
import {getLocationPermission, useDidMount} from 'utils'
import {useTranslation} from 'i18n'
import {useDispatch, useSelector} from 'lib/redux'
import {TemplateAuthAccessFullPage} from '../../../template'
import {GiftShopRootScreen} from '../../../gift-shop'
import {TreeFototreeModal, TreeLocPermissionModal} from '../containers'

export default function TreeFototreeScreen() {
  const {translate} = useTranslation()
  const {access_token} = useSelector('user') || {}
  const permissionModalState = useState<boolean>(false)
  const {update} = useDispatch()
  const [modal, setModal] = permissionModalState
  const [permission, setPermission] = useState<gpsPermissionState>('denied')

  const handleErrorLocation = useCallback(() => {
    setModal(true)
  }, [setModal])

  const handleSuccessLocation = useCallback(
    (position: GeolocationPosition) => {
      setModal(false)
      setPermission('granted')
      update('user', {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      })
    },
    [setModal, update],
  )

  const handlePermission = useCallback(
    (res: PermissionStatus) => {
      setPermission(res.state)

      if (res.state !== 'granted') setModal(true)

      if (res.state === 'granted' || res.state === 'prompt') {
        navigator.geolocation.getCurrentPosition(
          handleSuccessLocation,
          handleErrorLocation,
          {enableHighAccuracy: true},
        )
      }
    },
    [handleErrorLocation, handleSuccessLocation, setModal],
  )

  useDidMount(() => {
    getLocationPermission(handlePermission, () => {})
  })

  const handleRenderPermissionModal = useMemo(
    () => (
      <TreeLocPermissionModal
        visible={modal}
        toggleModal={() => setModal(!modal)}
      />
    ),
    [modal, setModal],
  )

  return !access_token ? (
    <GiftShopRootScreen
      headerTitle={translate('global:fototree')}
      showLanguageToggle
      showBackIcon={false}
      showBadgeIcon={false}>
      <TemplateAuthAccessFullPage />
    </GiftShopRootScreen>
  ) : (
    <>
      <TreeFototreeModal
        permissionModal={permissionModalState}
        gpsEnabled={permission === 'granted'}
      />
      {handleRenderPermissionModal}
    </>
  )
}
